<template>
  <b122-login
    login-title="Bienvenue sur Clinique des NAC"
    login-subtitle="Connectez-vous pour accéder à la solution"
    logo="logo.png"
  ></b122-login>
</template>

<script>
import B122Login from "../../components/b122/B122Login";

export default {
  name: "Login",
  components: {
    B122Login
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/auth/Login.vue